import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { GET_STORE_DETAILS } from '../../operations/queries/get-store-details.js';
import fromStoreQueryDataToStoreDetails from './adapters/fromStoreQueryDataToStoreDetails.js';

const useStoreDetails = ()=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_DETAILS, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        fetchPolicy: 'no-cache'
    });
    const data = React.useMemo(()=>{
        var ref;
        const storeQueryData = (ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store;
        return fromStoreQueryDataToStoreDetails(storeQueryData);
    }, [
        queryState.data
    ]);
    const getStoreDetails = React.useCallback((slugOrCode)=>{
        query({
            variables: {
                [typeof slugOrCode === 'string' ? 'slug' : 'code']: slugOrCode
            }
        });
    }, [
        query
    ]);
    React.useEffect(()=>{
        if (queryState.error) {
            console.error('Failed to fetch store details: ', queryState.error);
        }
    }, [
        queryState.error
    ]);
    return React.useMemo(()=>[
            getStoreDetails,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        getStoreDetails,
        queryState,
        data
    ]);
};
var useStoreDetails$1 = useStoreDetails;

export { useStoreDetails$1 as default, useStoreDetails };
//# sourceMappingURL=use-store-details.js.map
